import React, { useState, useEffect } from 'react';
import Modal from '../../Modal';
import EditorReviewFilesModal from './EditorReviewFilesModal';
import EditorFileRow from './EditorFileRow';

const Main = ({articleId, whiteList}) => {

  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    fetchEditorFiles();
    const handleWindowDragOver = (e) => e.preventDefault();
    const handleWindowDrop = (e) => e.preventDefault();
    window.addEventListener('dragover', handleWindowDragOver);
    window.addEventListener('drop', handleWindowDrop);
    return () => {
      window.removeEventListener('dragover', handleWindowDragOver);
      window.removeEventListener('drop', handleWindowDrop);
    };
  }, [])

  const openModal = (initialFile=null) => {
    Modal.open({
      children: <EditorReviewFilesModal
                  setFiles={setFiles}
                  initialFile={initialFile}
                  articleId={articleId}
                  whiteList={whiteList}
                />
    })
  }

  const fetchEditorFiles = () => {
    $.ajax({
      type: 'GET',
      url: `/publish/articles/${articleId}/editor_review_files`,
      dataType: 'json',
      success: function(res) {
        setFiles(res.content_files)
      }
    })
  }

  const onDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const contentFile = e.dataTransfer?.files?.[0] ?? null;
    if (contentFile instanceof File) openModal(contentFile);
  };

  return (
    <div className="files-for-editor-review">
      <div className="row">
        <div className="large-12 columns">
          <EditorFileRow articleId={articleId} files={files} setFiles={setFiles} />
        </div>
      </div>
      <div className="row">
        <div className="large-12 columns">
          <div className="text-center file-upload-section">  
            <div
              className={`upload-container ${isDragging ? 'drag-over' : ''}`}
              onClick={() => openModal()}
              onDragEnter={onDragEnter}
              onDragOver={onDragOver}
              onDragLeave={onDragLeave}
              onDrop={onDrop}
              role="button"
            >
              <img className='file-upload-img' src="https://public.cureus.com/channel_design/internal_upload_icon_4x.png" />
              <span>Upload a File</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Main;